import React from 'react';

import { TCard } from '@/services/requests/Recommendation/types/template7';

type TSliderDotsProps = {
  cards: TCard[];
  currentSlide: number;
  template: string;
};

export const SliderDots = (props: TSliderDotsProps) => {
  const { cards, currentSlide, template } = props;

  return (
    <div className={`${template}s`}>
      {cards.map((card, i) => {
        const item = i + 1;
        const isCurrent = i + 1 === currentSlide;
        return (
          <span
            key={card.id}
            className={`${template}${isCurrent ? ' current' : ''}`}
          >
            {item}
          </span>
        );
      })}
    </div>
  );
};
